export type DeploymentEnv = "local" | "staging" | "production";

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || "http://localhost:8000";
const mediaBaseUrl = import.meta.env.VITE_MEDIA_BASE_URL || "http://localhost:8000";
const deploymentEnv = (import.meta.env.VITE_DEPLOYMENT_ENV || "local") as DeploymentEnv;

export const env = {
  apiBaseUrl,
  mediaBaseUrl,
  deploymentEnv,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
};

/** Full versioned API URL */
export const API_URL = `${apiBaseUrl.replace(/\/$/, "")}/api/v1`;

/** Base URL for media files (served by main backend) */
export const MEDIA_URL = mediaBaseUrl.replace(/\/$/, "");
